import { useEffect, useRef } from "react";
import "../style/Bubbles.css";

let bubblePositions = [];

function BubblesPage({ cards, viewMode }) {
  const stageRef = useRef(null);

  const getColsAndSizes = () => {
    const width = window.innerWidth;
    let cols, minSize, maxSize, fontSize;

    if (width <= 340) {
      cols = 3; minSize = 10; maxSize = 60; fontSize = "0.7rem";
    } else if (width <= 460) {
      cols = 3; minSize = 60; maxSize = 100; fontSize = "0.8rem";
    } else if (width <= 480) {
      cols = 5; minSize = 40; maxSize = 80; fontSize = "0.6rem";
    } else if (width <= 668) {
      cols = 5; minSize = 60; maxSize = 90; fontSize = "0.7rem";
    } else if (width <= 768) {
      cols = 5; minSize = 60; maxSize = 100; fontSize = "0.9rem";
    } else if (width <= 1279) {
      cols = 5; minSize = 80; maxSize = 140; fontSize = "1rem";
    } else if (width <= 1380) {
      cols = 6; minSize = 100; maxSize = 160; fontSize = "1.4rem";
    } else if (width <= 1580) {
      cols = 6; minSize = 140; maxSize = 200; fontSize = "1.6rem";
    } else if (width <= 2180) {
      cols = 6; minSize = 160; maxSize = 210; fontSize = "1.6rem";
    } else if (width <= 2899) {
      cols = 6; minSize = 280; maxSize = 300; fontSize = "2.5rem";
    } else {
      cols = 7; minSize = 400; maxSize = 410; fontSize = "4.2rem";
    }

    return { cols, minSize, maxSize, fontSize };
  };

  const renderList = () => {
    const stage = stageRef.current;
    if (!stage) return;

    stage.innerHTML = "";

    const div = document.createElement("div");
    div.className = "div-class";
    const list = document.createElement("ul");
    list.className = "simple-list";

    const slugify = (text) =>
      text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");


    cards.forEach(card => {
      const li = document.createElement("li");
      li.textContent = card.Title;

      const slug = slugify(card.Title);

      li.addEventListener("click", () => {
        window.location.href = `/details/${card.id}-${slug}`;
      });

      list.appendChild(li);
    });

    div.appendChild(list);
    stage.appendChild(div);
  };

  const renderBubbles = () => {
    const stage = stageRef.current;
    if (!stage) return;

    const texts = cards.map(card =>
      card.Title.length > 20
        ? card.Title.slice(0, 64)
        : card.Title
    );

    const rect = stage.getBoundingClientRect();
    const { cols, minSize, maxSize, fontSize } = getColsAndSizes();
    const width = rect.width;
    const height = rect.height;

    const rows = Math.ceil(texts.length / cols);
    const cellWidth = width / cols;
    const cellHeight = height / rows;

    bubblePositions = [];

    const placed = texts.map((t, i) => {
      const col = i % cols;
      const row = Math.floor(i / cols);

      const size = Math.min(
        maxSize,
        Math.max(minSize, t.length * 7)
      );

      let x = col * cellWidth + cellWidth / 2;
      let y = row * cellHeight + cellHeight / 2;

      x += (Math.random() - 0.5) * cellWidth * 0.4;
      y += (Math.random() - 0.5) * cellHeight * 0.4;

      return { x, y, size };
    });

    bubblePositions = placed;
    stage.innerHTML = "";

    const bgList = [
      "var(--bubble1)", "var(--bubble2)", "var(--bubble3)",
      "var(--bubble4)", "var(--bubble5)", "var(--bubble6)",
      "var(--bubble7)", "var(--bubble8)", "var(--bubble9)"
    ];

    texts.forEach((t, i) => {
      const { x, y, size } = bubblePositions[i];
      const bubble = document.createElement("div");
      const slugify = (text) =>
            text
              .toLowerCase()
              .trim()
              .replace(/[^\w\s-]/g, "")
              .replace(/\s+/g, "-");

      const slug = slugify(cards[i].Title);
      bubble.className = "bubble";
      bubble.textContent = t;

      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      bubble.style.left = `${x - size / 2}px`;
      bubble.style.top = `${y - size / 2}px`;
      bubble.style.fontSize = fontSize;
      bubble.style.backgroundColor = bgList[Math.floor(Math.random() * bgList.length)];

      bubble.addEventListener("click", () => {
        window.location.href = `/details/${cards[i].id}-${slug}`;
      });

      stage.appendChild(bubble);
    });
  };

  useEffect(() => {
    if (!cards.length) return;

    if (viewMode === "bubbles") {
      renderBubbles();
    } else {
      renderList();
    }

    const handleResize = () => {
      if (viewMode === "bubbles") {
        renderBubbles();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [cards, viewMode]);

  return <main className="bubbles-container" ref={stageRef}></main>;
}

export default BubblesPage;
